import React from "react";
import styles from "./RubleInput.module.scss";

const RubleInput = ({ amount, setAmount }) => {
  const formatNumber = (value) => {
    const cleanValue = value.replace(/[^\d.]/g, "");
    const [integerPart, decimalPart] = cleanValue.split(".");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return decimalPart
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const handleAmountChange = (e) => {
    const rawValue = e.target.value;
    setAmount(formatNumber(rawValue));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.inputContainer}>
        <input
          type="text"
          value={amount}
          onChange={handleAmountChange}
          placeholder="Введите сумму"
          className={styles.input}
        />
        {amount && <span className={styles.rubleSign}>₽</span>}
      </div>
    </div>
  );
};

export default RubleInput;
